import moment from "moment";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

const FemaleCycleMenstrualIndicator = ({
  currentLog,
  lastLog,
  athleteId,
  query,
}) => {
  const { t } = useTranslation("athlete-portal");
  const isCurrentlyInPeriod = !!currentLog;
  const hasNoLogs = !currentLog && !lastLog;
  const date = moment();

  const daysInCurrentPeriod = currentLog
    ? moment()
        .add(1, "day")
        .diff(moment(currentLog.startDate, "YYYYMMDD"), "days")
    : 0;

  const lastPeriodEndDate = lastLog?.endDate
    ? moment(lastLog.endDate, "YYYYMMDD").format("MMM D, YYYY")
    : "N/A";

  const reportsUrl = athleteId
    ? `/athlete-portal/metrics/female-cycle?date=${date.format("YYYYMMDD")}&athlete=${athleteId}${query?.organizationCoach ? `&organizationCoach=${query.organizationCoach}` : ""}`
    : "#";

  return (
    <a
      href={reportsUrl}
      className={`flex flex-row mt-4 gap-2 p-2 rounded-2xl items-center no-underline cursor-pointer ${
        isCurrentlyInPeriod ? "bg-[#D7567A] text-white" : "bg-(--white-05)"
      }`}
    >
      <div
        className={`flex items-center justify-center px-[14px] py-[10px] rounded-full w-10 h-10 ${
          isCurrentlyInPeriod ? "bg-white text-[#D7567A]" : "bg-(--white-10)"
        }`}
      >
        <SvgIcon
          classNames="blood-icon"
          src={`/img/new-icons/blood-drop-icon.svg`}
          noFilterOnLight={true}
        />
      </div>
      <div>
        {isCurrentlyInPeriod && (
          <div>
            <div>
              <p className="font-bold font-size-14">
                {t("femaleCycleIndicator.dayLabel", { day: daysInCurrentPeriod })}
              </p>
            </div>
            <div>
              <p className="p2 text-white">{t("femaleCycleIndicator.currentlyOnPeriod")}</p>
            </div>
          </div>
        )}
        {hasNoLogs && (
          <div>
            <div>
              <p className="font-bold font-size-14">{t("femaleCycleIndicator.title")}</p>
            </div>
            <div>
              <p className="p2">{t("femaleCycleIndicator.waitingForData")}</p>
            </div>
          </div>
        )}
        {!isCurrentlyInPeriod && !hasNoLogs && (
          <div>
            <div>
              <p className="font-bold font-size-14">{t("femaleCycleIndicator.title")}</p>
            </div>
            <div>
              <p className="p2">{t("femaleCycleIndicator.lastDate", { date: lastPeriodEndDate })}</p>
            </div>
          </div>
        )}
      </div>
    </a>
  );
};

export default FemaleCycleMenstrualIndicator;
